import Vue from "vue";
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'columnist',
            component: resolve => require(['../pages/columnist/columnist.vue'], resolve)
        },
        {
            path: '/columnist',
            name: 'columnist',
            component: resolve => require(['../pages/columnist/columnist.vue'], resolve)
        },
        {
            path: '/columnist/hospitals',
            name: 'hospitals',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/hospitals/hospitals.vue'], resolve)

        },
        // app内嵌文章详情页
        {
            path: '/articleDetail',
            name: 'articleDetail',
            component: resolve => require(['../pages/articleDetail.vue'], resolve)
        },
        {
            path: '/articleShare',
            name: 'articleShare',
            component: resolve => require(['../pages/articleShare.vue'], resolve)
        },
        // 营养饮食付费文章分享
        {
            path: '/articlePayShare',
            name: 'articlePayShare',
            component: resolve => require(['../pages/articlePayShare.vue'], resolve)
        },
        // 音频分享
        {
            path: '/audioShare',
            name: 'audioShare',
            component: resolve => require(['../pages/audioShare.vue'], resolve)
        },
        {
            path: '/agreement', //隐私权政策
            name: 'agreement',
            meta: {
                title: '隐私权政策'
            },
            component: resolve => require(['../pages/agreement/privacy.vue'], resolve)
        },
        {
            path: '/agreement/privacy', //隐私权政策
            name: 'agreementPrivacy',
            meta: {
                title: '隐私权政策'
            },
            component: resolve => require(['../pages/agreement/privacy.vue'], resolve)
        },
        {
            path: '/agreement/user', //用户协议
            name: 'agreementUser',
            meta: {
                title: '用户协议'
            },
            component: resolve => require(['../pages/agreement/user.vue'], resolve)
        },
        {
            path: '/agreement/member', //会员权益协议
            name: 'agreementMember',
            meta: {
                title: '会员服务协议'
            },
            component: resolve => require(['../pages/agreement/member.vue'], resolve)
        },
        {
            path: '/mediaDetail',
            name: 'mediaDetail',
            component: resolve => require(['../pages/mediaDetail.vue'], resolve)
        },
        // 课程分享
        {
            path: '/vedioShare',
            name: 'vedioShare',
            component: resolve => require(['../pages/vedioShare.vue'], resolve)
        },
        {
            path: '/courseSummary',
            name: 'courseSummary',
            component: resolve => require(['../pages/courseSummary.vue'], resolve)
        },
        {
            path: '/notice',
            name: 'notice',
            component: resolve => require(['../pages/notice.vue'], resolve)
        },
        {
            path: '/audioSummary',
            name: 'audioSummary',
            component: resolve => require(['../pages/audioSummary.vue'], resolve)
        },
        {
            path: '/columnist/detail',
            name: 'columnistDetail',
            component: resolve => require(['../pages/columnist/detail.vue'], resolve)
        },
        {
            path: '/columnist/audioDetail',
            name: 'audioDetail',
            component: resolve => require(['../pages/columnist/audioDetail.vue'], resolve)
        },
        {
            path: '/columnist/videoDetail',
            name: 'videoDetail',
            component: resolve => require(['../pages/columnist/videoDetail.vue'], resolve)
        },
        {
            path: '/columnist/list',
            name: 'list',
            component: resolve => require(['../pages/columnist/list.vue'], resolve)
        },
        {
            path: '/question',
            name: 'question',
            component: resolve => require(['../pages/question.vue'], resolve)
        },
        {
            path: '/informedNotice', // 知情同意书
            name: 'informedNotice',
            meta: {
                title: '知情同意书'
            },
            component: resolve => require(['../pages/informedNotice.vue'], resolve)
        },
        {
            path: '/promise', // 责任承诺书
            name: 'promise',
            meta: {
                title: '责任承诺书'
            },
            component: resolve => require(['../pages/promise.vue'], resolve)
        },
        {
            path: '/doctorShare',
            name: 'doctorShare',
            component: resolve => require(['../pages/doctorShare.vue'], resolve)
        },
        {
            path: '/course', // 课程分享页
            name: 'course',
            component: resolve => require(['../pages/course/index.vue'], resolve)
        },
        {
            path: '/courseDetails', // 课程详情分享页
            name: 'courseDetails',
            component: resolve => require(['../pages/courseDetails.vue'], resolve)
        },
        {
            path: '/messageBoard', // 留言板分享页
            name: 'messageBoard',
            component: resolve => require(['../pages/messageBoard.vue'], resolve)
        },
        {
            path: '/topic', // 话题分享页
            name: 'topic',
            component: resolve => require(['../pages/topic/index.vue'], resolve)
        },
        {
            path: '/recommend', // 推荐app分享页面
            name: 'recommend',
            component: resolve => require(['../pages/recommend'], resolve)
        },
        {
            path: '/pdfguidance', // pdf引导页面
            name: 'pdfguidance',
            component: resolve => require(['../pages/pdfguidance'], resolve)
        },
        {
            path: '/caseHistory', // 病历报告单
            name: 'caseHistory',
            meta: {
                title: '病历报告单'
            },
            component: resolve => require(['../pages/caseHistory'], resolve)
        },
        {
            path: '/caseHistoryDetail', // 病历报告单详情页
            name: 'caseHistoryDetail',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/caseHistory/detail.vue'], resolve)
        },
        {
            path: '/caseHistoryPdfDetail', // 病历报告单pdf详情页
            name: 'caseHistoryPdfDetail',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/caseHistory/pdfDetail.vue'], resolve)
        },
        {
            path: '/publicColumn', // 公众号专栏引导
            name: 'publicColumn',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/publicColumn'], resolve)
        },
        {
            path: '/chat', // 聊天分享页
            name: 'chat',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/chat'], resolve)
        },
        {
            path: '/geneDetection', // 基因检测
            name: 'geneDetection',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection'], resolve)
        },
        {
            path: '/queryDetail', // 基因检测问题详情页
            name: 'queryDetail',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection/queryDetail'], resolve)
        },
        {
            path: '/shopDetail', // 基因检测详情页
            name: 'shopDetail',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection/shopDetail'], resolve)
        },
        {
            path: '/reservedMobile', // 基因检测预留电话
            name: 'reservedMobile',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection/reservedMobile'], resolve)
        },
        {
            path: '/geneDetection/agreement', // 基因检测服务协议
            name: 'geneDetectionAgreement',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection/agreement'], resolve)
        },
        {
            path: '/geneDetectionSuccer', // 基因检测预定成功页
            name: 'geneDetectionSuccer',
            meta: {
                title: '基因检测'
            },
            component: resolve => require(['../pages/geneDetection/geneDetectionSuccer'], resolve)
        },
        {
            path: '/jingService', // 进京就医
            name: 'jingService',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/jingService/index'], resolve)
        },
        {
            path: '/jingServiceDetail', // 进京就医详情页
            name: 'jingServiceDetail',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/jingService/detail'], resolve)
        },
        {
            path: '/reservedPhone', // 进京就医详情页
            name: 'reservedPhone',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/jingService/reservedPhone'], resolve)
        },
        {
            path: '/restService', // 进京就医详情页
            name: 'restService',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/jingService/restService'], resolve)
        },
        {
            path: '/jingServiceAgreement', //来京就医协议
            name: 'jingServiceAgreement',
            meta: {
                title: '来京就医服务协议'
            },
            component: resolve => require(['../pages/jingService/jingServiceAgreement'], resolve)
        },
        {
            path: '/liveStreaming', //直播分享页
            name: 'liveStreaming',
            meta: {
                title: '直播'
            },
            component: resolve => require(['../pages/liveStreaming/index'], resolve)
        },
        {
            path: '/live', //直播详情页分享
            name: 'live',
            meta: {
                title: '往期精彩'
            },
            component: resolve => require(['../pages/liveDetail/index'], resolve)
        },
        {
            path: '/recall', //短信召回
            name: 'recall',
            meta: {
                title: '短信召回'
            },
            component: resolve => require(['../pages/recall/index'], resolve)
        },
        {
            path: '/clinicalTrial', //临床招募
            name: 'clinicalTrial',
            meta: {
                title: '临床招募'
            },
            component: resolve => require(['../pages/clinicalTrial/index.vue'], resolve)
        },
        {
            path: '/clinicalTrial/project', //临床招募
            name: 'clinicalTrialProject',
            meta: {
                title: '临床招募'
            },
            component: resolve => require(['../pages/clinicalTrial/project.vue'], resolve)
        },
        {
            path: '/clinicalTrial/projectDetail', //临床招募项目详情页
            name: 'clinicalTrialProjectDetail',
            meta: {
                title: '临床招募'
            },
            component: resolve => require(['../pages/clinicalTrial/projectDetail.vue'], resolve)
        },
        {
            path: '/clinicalTrial/clinicalTrialForm', //免费用药申请表
            name: 'clinicalTrialClinicalTrialForm',
            meta: {
                title: '免费用药申请表',
                keepAlive: true
            },
            component: resolve => require(['../pages/clinicalTrial/clinicalTrialForm.vue'], resolve)
        },
        {
            path: '/selectCancer', //癌种亚型选择
            name: 'selectCancer',
            meta: {
                title: '选择癌种亚型'
            },
            component: resolve => require(['../pages/selectCancer'], resolve)
        },
        {
            path: '/selectCancerDetail', //癌种亚型选择
            name: 'selectCancerDetail',
            meta: {
                title: '选择癌种亚型'
            },
            component: resolve => require(['../pages/selectCancer/goDetail.vue'], resolve)
        },
        {
            path: '/success', //临床招募成功页
            name: 'success',
            meta: {
                title: '感谢您的信任'
            },
            component: resolve => require(['../pages/success/index.vue'], resolve)
        },
        {
            path: '/bannerDetail', //临床招募成功页
            name: 'bannerDetail',
            meta: {
                title: ''
            },
            component: resolve => require(['../pages/clinicalTrial/bannerDetail.vue'], resolve)
        },
        {
            path: '/siteAll', //查看全部地点
            name: 'siteAll',
            meta: {
                title: '全部地点'
            },
            component: resolve => require(['../pages/clinicalTrial/siteAll.vue'], resolve)
        },
        {
            path: '/articleShow', //帮助分享
            name: 'articleShow',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/articleShow'], resolve)
        },
        {
            path: '/downLoadLCZM', //临床招募下载app页面
            name: 'downLoadLCZM',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/downLoadLCZM'], resolve)
        },
        {
            path: '/hpvActivity', //hpv活动页
            name: 'hpvActivity',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/hpvActivity'], resolve)
        },
        {
            path: '/hpvInvite', //hpv助力页
            name: 'hpvInvite',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/hpvInvite'], resolve)
        },
        {
            path: '/hpvSuccess', //hpv提交成功页面
            name: 'hpvSuccess',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/hpvSuccess'], resolve)
        },
        {
            path: '/hpvFinish', //hpv活动结束页
            name: 'hpvFinish',
            meta: {
                title: '癌度'
            },
            component: resolve => require(['../pages/hpvFinish'], resolve)
        },
        // 速愈素
        {
            path: '/activitySYS',
            name: 'activitySYS',
            meta: {
                title: '速愈素',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/activitySYS'], resolve)

        },
        // 拉新活动页
        {
            path: '/activity',
            name: 'activity',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/activity'], resolve)

        },
        // 拉新活动详情页
        {
            path: '/activity/detail',
            name: 'activity_detail',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/activity/detail.vue'], resolve)
        },
        // 拉新活动助力页
        {
            path: '/activity/help',
            name: 'activity_help',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/activity/help.vue'], resolve)
        },
        // 快讯详情页
        {
            path: '/content/newsflash',
            name: 'content_newsflash',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/content/newsflash.vue'], resolve)
        },
        // 快讯详情页
        {
            path: '/content/experience',
            name: 'content_experience',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/content/experience.vue'], resolve)
        },
        // 日报活动页
        {
            path: '/daily',
            name: 'daily',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/daily/index.vue'], resolve)
        },
        // 日报登录页
        {
            path: '/daily/login',
            name: 'dailyLogin',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/daily/login.vue'], resolve)
        },
        // 日报下载页
        {
            path: '/daily/download',
            name: 'dailyDownload',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/daily/download.vue'], resolve)
        },
        // 征稿页面
        {
            path: '/contribute',
            name: 'contribute',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/contribute/contribute.vue'], resolve)
        },
        // 病历图表页面
        {
            path: '/charts/tumorSize',
            name: 'tumorSize',
            meta: {
                title: '癌度',
                icon: 'el-icon-tickets'
            },
            component: resolve => require(['../pages/charts/tumorSize.vue'], resolve)
        }

    ]
})
router.beforeEach((to, from, next) => {
    if (window.location.href.indexOf('urlName') == -1) {
        if (window.location.href.indexOf('?') == -1) {
            window.location.replace(window.location.href+"?urlName="+to.path)
        } else {
            window.location.replace(window.location.href+"&urlName="+to.path)
        }
    }
    window.document.title = to.meta.title || '癌度'
    next()
})
export default router